import styled, { css } from 'styled-components';

export const MainSubIconsContainer = styled.div`
  position: absolute;
  top: 5vh;
  display: flex;
  flex-direction: column;
  min-height: 95vh;
  background: ${(props) => props.theme.mainSubBg};
  z-index: 10;
`;

export const SubIcon = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  & > svg {
    height: 30px;
    width: 30px;
    fill: #60687d;

    ${(props) =>
      props.selected &&
      css`
        fill: #fff;
      `}
  }

  & > svg:hover {
    fill: #fff;
  }
`;

export const SubIconTypeMenu = styled.div`
  position: absolute;
  flex-direction: column;
  width: 50px;
  min-height: 100px;
  left: 50px;
  top: 100px;
  background: #101010;

  ${(props) =>
    props.iconSubView
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `}

  & > div:nth-child(2) > svg {
    transform: rotate(90deg);
  }
`;

export const TypeIcon = styled.div`
  cursor: pointer;
  text-align: center;

  & > svg {
    width: 30px;
    height: 50px;
    fill: #60687d;

    ${(props) =>
      props.selected &&
      css`
        fill: #fff;
      `}
  }

  & > svg:hover {
    fill: #fff;
  }
`;
